/**
 * 연차 관련 상수 정의
 * @description 연차 유형, 라벨, 색상 등의 상수를 중앙 관리
 */

/**
 * 연차 유형 코드
 */
export const VACATION_TYPES = {
    FULL: 'FULL',  // 전일 연차
    AM: 'AM',      // 오전 반차
    PM: 'PM'       // 오후 반차
};

/**
 * 연차 유형별 한글 라벨
 */
export const VACATION_TYPE_LABELS = {
    [VACATION_TYPES.FULL]: '연차',
    [VACATION_TYPES.AM]: '오전',
    [VACATION_TYPES.PM]: '오후'
};

/**
 * 연차 유형별 색상 정의 (중립적인 색상 사용)
 * @property {string} bg - 배경색
 * @property {string} text - 텍스트 색상
 */
export const VACATION_TYPE_COLORS = {
    [VACATION_TYPES.FULL]: { bg: '#e2e8f0', text: '#475569' },  // 회색 계열 (슬레이트)
    [VACATION_TYPES.AM]: { bg: '#fef9c3', text: '#854d0e' },    // 연한 노랑 계열
    [VACATION_TYPES.PM]: { bg: '#e0e7ff', text: '#3730a3' }     // 연한 인디고 계열
};

/**
 * 연차 유형 라벨 반환 유틸리티 함수
 * @param {string} type - 연차 유형 코드
 * @returns {string} 한글 라벨
 */
export function getVacationTypeLabel(type) {
    return VACATION_TYPE_LABELS[type] || type;
}

/**
 * 연차 유형 색상 반환 유틸리티 함수
 * @param {string} type - 연차 유형 코드
 * @returns {Object} { bg, text } 색상 객체
 */
export function getVacationTypeColor(type) {
    return VACATION_TYPE_COLORS[type] || VACATION_TYPE_COLORS[VACATION_TYPES.FULL];
}
